var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePauseButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-HomePauseButton"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HomePauseButton",
    clipPath: "url(#clip-HomePauseButton)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_548",
    "data-name": "Ellipse 548",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(5 5)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-play",
    "data-name": "Icon ionic-ios-play",
    d: "M9,7.121V20.662a.349.349,0,0,0,.522.321l10.734-6.77a.384.384,0,0,0,0-.638L9.522,6.8A.345.345,0,0,0,9,7.121Z",
    transform: "translate(9 8.249)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePauseButton);
export default __webpack_public_path__ + "static/media/HomePauseButton.7743e959bab023ddd127edd89104f7c5.svg";
export { ForwardRef as ReactComponent };